import {SubPageHero} from "../hero/Hero";
import React, {useState} from "react";
import {YearSelectorComponent} from "../../components/selector/YearSelectorComponent";
import {API, Entities} from "../../utils/Api";

export function GalleryBlock({yearsData,galleryData}) {
    const [gallery,setGallery] = useState(galleryData);
    const [selectedYear, setSelectedYear] = useState(yearsData[0]);
    console.log(galleryData)

    async function handleYearSelect(year){
        try {
            const response = await API.rest(Entities.gallery, "GET",{},year); // Várjuk meg az API választ
            if(!response['error_code'])
            {
                setGallery(response);
            }
            else{
                setGallery({kepek:[],videok:[]})
            }
        } catch (error) {
            console.error("Hiba történt az API hívás során:", error);
            return { gallery: []}; // Hiba esetén üres tömböt adunk vissza
        }
        setSelectedYear(year);
    }

    return (<>
        <section className="g-white pt-4 sm-pt-50px mt--50px-imp">
            <div className="container"
                 data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0, 1], "duration": 800, "delay": 200, "staggervalue": 150, "easing": "easeOutQuad" }'>
                <div style={{marginBottom: "30px"}}><YearSelectorComponent years={yearsData} onSelectYear={handleYearSelect}
                                                                           selectedYear={selectedYear}/></div>
                <GalleryVideoComponent videos={gallery.videok} year={selectedYear}></GalleryVideoComponent>
                <GalleryImgComponent images={gallery.kepek}  year={selectedYear}></GalleryImgComponent>
            </div>
        </section>
    </>)
}


function GalleryVideoComponent({videos,year}) {
    var json = videos?.length>0 ? videos.map((video)=>{return {srcUrl:video.external_url,name:video.cim,iframe:video.leiras}}):[];
    return (<>
                <div className="row justify-content-center mb-3">
                    <div className="col-xl-6 col-lg-8 text-center"
                         data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 150, "easing": "easeOutQuad" }'>
                        <span className="fs-15 mb-5px text-base-color fw-700 d-inline-block text-uppercase ls-1px">BENEFIT PRIZE {year}</span>
                        <h3 className="alt-font text-dark-gray ls-minus-1px">Videók</h3>
                    </div>
                    <div className="row row-cols-1 row-cols-lg-3 row-cols-sm-2">
                        {json.map((block, idx) => {
                            return <GalleryVideoItem key={idx} {...block}></GalleryVideoItem>;
                        })}
                    </div>
                </div>
        </>
    )
}

function GalleryVideoItem({srcUrl, name,iframe}) {
    return (
        <div  style={{width:'fit-content'}} className="col text-center fit-videos md-mb-50px sm-mb-30px">
            <div dangerouslySetInnerHTML={{__html:iframe}} style={{width:'fit-content'}}></div>
            <div className="text-dark-gray fs-18 fw-600 mt-6 word-break-normal"></div>
        </div>
    )
}


function GalleryImgComponent({images,year}) {
    return (
        <section className="ps-5 pe-5 lg-ps-2 lg-pe-2">
            <div className="col-xl-13 col-lg-13 text-center"
                 data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 150, "easing": "easeOutQuad" }'>
                <span className="fs-15 mb-5px text-base-color fw-700 d-inline-block text-uppercase ls-1px">BENEFIT PRIZE {year}</span>
                <h3 className="alt-font text-dark-gray ls-minus-1px">Képek</h3>
            </div>
            <div className="container-fluid">
                <div className="row">
                    <div className="col">
                        <ul style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))", gap: "20px" }}>
                            <li className="grid-sizer d-none"></li>
                            {
                                images.map((img,idx)=>{
                                    return <GalleryImgItem key={idx} {...img}></GalleryImgItem>
                            })
                            }
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}

function GalleryImgItem({...props}){
    return(
        <li className="grid-item" >
            <div className="atropos-scale">
                <div className="atropos-rotate">
                    <div>
                        <div className="gallery-box"><a href={props.preview}
                                                        data-group="lightbox-group-gallery-item-2"
                                                        title="Lightbox gallery image title">
                            <div className="position-relative gallery-image bg-slate-blue">
                                <img src={props.preview?props.preview:"https://placehold.co/800x743"} alt=""/>
                                <div
                                    className="d-flex align-items-center justify-content-center position-absolute top-0px left-0px w-100 h-100 gallery-hover move-bottom-top">
                                    <i className="bi bi-camera icon-medium text-white"></i>
                                </div>
                            </div>
                        </a>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    )
}
